import { __require as requireSemver } from "../classes/semver.js";
var patch_1;
var hasRequiredPatch;
function requirePatch() {
  if (hasRequiredPatch) return patch_1;
  hasRequiredPatch = 1;
  const SemVer = requireSemver();
  const patch = (a, loose) => new SemVer(a, loose).patch;
  patch_1 = patch;
  return patch_1;
}
export {
  requirePatch as __require
};
//# sourceMappingURL=patch.js.map
